    document.addEventListener("DOMContentLoaded", function() {
  var thumbSwiper = new Swiper(".custom-featured-product .thumbSwiper", {
    spaceBetween: 25,
    slidesPerView: 5,
    watchSlidesProgress: true,
    loop: false, 
    navigation: {
      nextEl: ".custom-featured-product .thumbSwiper .swiper-button-next",
      prevEl: ".custom-featured-product .thumbSwiper .swiper-button-prev",
    },
    breakpoints: {
      769: { 
        direction: "horizontal",
      },
      481: { 
        direction: "horizontal",
      },
0: { 
          slidesPerView: 4,
           spaceBetween: 12,
      }
    }
  });

  var featuredSwiper = new Swiper(".custom-featured-product .featuredSwiper", {
    spaceBetween: 1,
    slidesPerView: 1,
     autoHeight: true,
    navigation: {
      nextEl: ".custom-featured-product .featuredSwiper .swiper-button-next",
      prevEl: ".custom-featured-product .featuredSwiper .swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
});

$(document).ready(function() {
  $(".custom-featured-product .desc_wrapper").each(function() {
    var $wrapper = $(this);
    var $desc2 = $wrapper.find(".desc2");
     var $desc1 = $wrapper.find(".desc1");
    var $readMore = $wrapper.find(".read_more");
    var $readLess = $wrapper.find(".read_less");

    $readMore.on("click", function() {
      $desc2.stop(true, true).slideDown(600);  // show extended desc
      $readMore.hide();                        // hide "Read More"
      $readLess.show(); 
      $desc1.hide();// show "Read Less"
    });

    $readLess.on("click", function() {
      $desc2.stop(true, true).slideUp(600);    // hide extended desc
      $readLess.hide();                         // hide "Read Less"
      $readMore.show(); 
        $desc1.show();                        // show "Read More"
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".custom-featured-product .featured_video")
    .forEach(function (wrap) {

      const video = wrap.querySelector("video");
      const playIcon = wrap.querySelector(".play_icon");

      if (!video || !playIcon) return;

      // Click play icon → play video
      playIcon.addEventListener("click", function (e) {
        e.stopPropagation();
        video.play();
        playIcon.classList.add("hide");
      });

      // Click video → pause video
      video.addEventListener("click", function () {
        if (!video.paused) {
          video.pause();
          playIcon.classList.remove("hide");
        }
      });

      // When video ends → show icon again
      video.addEventListener("ended", function () {
        playIcon.classList.remove("hide");
      });
    });
});


$(document).ready(function () {

  var $wrapper = $('.sort-wrapper');
  var $trigger = $('.sort-trigger');
  var $label   = $('.sort-trigger .label');
  var $items   = $('.template-collection .sort-list li');

  if (!$wrapper.length) return;

  // Open / close dropdown
  $trigger.on('click', function (e) {
    e.preventDefault();
    $(".template-collection .sort-list").slideToggle('');
  });

  // Click option → refresh with sort_by
  $items.on('click', function () {
    var sortValue = $(this).data('sort');
    if (!sortValue) return;

    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    window.location.href = url.toString();
  });

  // Restore selected label after refresh
  var $activeItem = $('.sort-list li.active');
  if ($activeItem.length) {
    $label.text($activeItem.text());
  }

  // Close on outside click
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.sort-wrapper').length) {
      $wrapper.removeClass('active');
    }
  });

});

document.addEventListener("DOMContentLoaded", function () {

  const triggers = document.querySelectorAll(
    ".collection-sidebar__group--1 .collection-sidebar__group .collapsible-trigger-btn"
  );

  const contents = document.querySelectorAll(
    ".collection-sidebar__group--1 .collection-sidebar__group .collapsible-content--sidebar"
  );

  triggers.forEach(el => el.classList.add("is-open"));
  contents.forEach(el => el.classList.add("is-open"));

});
